var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    uuid: "e645986d-a395-46f2-9d2a-6944ec235fb7",
    version: "0.0.1",
    organization: "Tina",
    project: "AnimatorWebsiteIcon6",
    branch: "master",
    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon6",
    username: "tina@haiku.ai",
    root: "https://cdn.haiku.ai/0f9a2fb9-3bf3-4c64-9b2d-1a9af15c3253/5c51f21e1f76d3ec3900c58fb722be9bdc65c090/",
    core: "4.5.1",
    title: "Deco1",
    type: "haiku",
    relpath: "code/deco1/code.js"
  },
  options: {},
  states: {},
  eventHandlers: {},
  timelines: {
    Default: {
      "haiku:Deco1-b2dcea53f1bacc28": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 13.03,
        "sizeAbsolute.y": 12.454,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:4c8abefde337": {
        "sizeAbsolute.y": 9,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 9,
        "sizeMode.x": 1,
        "style.margin": "0",
        "sizeMode.y": 1,
        "translation.x": 6.5089999999999995,
        "translation.y": 6.2219999999999995,
        "style.zIndex": 3,
        "rotation.z": {
          "0": { value: 0, edited: true, curve: "linear" },
          "667": { value: 6.284, edited: true }
        }
      },
      "haiku:fc731934eeb1": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:dac31d288103": {
        fill: "#F75D4A",
        "translation.x": -54,
        "translation.y": -16
      },
      "haiku:202ab700656b": {
        x: 55.4146654,
        y: 17.7146654,
        width: 5.94212411,
        height: 5.94212411,
        rx: 1,
        "translation.x": 5.009919,
        "translation.y": 52.115261,
        "rotation.z": 5.410521
      }
    }
  },
  template: {
    elementName: "div",
    attributes: {
      "haiku-id": "Deco1-b2dcea53f1bacc28",
      "haiku-title": "Deco1"
    },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "4c8abefde337",
          "haiku-title": "deco1",
          "haiku-source":
            "designs/AnimatorWebsiteIcon6.sketch.contents/slices/deco1.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: {
              "haiku-id": "fc731934eeb1",
              "haiku-title": "Page-1",
              id: "a6d1a92b457e"
            },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "dac31d288103",
                  "haiku-title": "Help-icon",
                  id: "5673b65e0086"
                },
                children: [
                  {
                    elementName: "rect",
                    attributes: {
                      "haiku-id": "202ab700656b",
                      "haiku-title": "deco1",
                      id: "c008e8ddfe68"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon6/code/deco1/code.js
// module id = 456
// module chunks = 127651196306611